import { IssueClient, IssuePropertiesDTO, IssueModel, NewIssueData, IssueFolioClient, IssueFolioModel, IssueViewerConfigClient, IssueViewerConfigDTO, SourceFileModel } from "../Generated/ParticaAPI";

export interface IIssueService {
	getIssueProperties(issueId: number): Promise<IssuePropertiesDTO>;
	getIssue(issueId: number): Promise<IssueModel>;
	DeleteIssue(issueId: number): Promise<any>;
	getIssueDomains(issueId: number): Promise<string[]>;
	getAccountIdForIssue(issueId: number): Promise<number>;
	CreateEmptyIssue(titleId: number, name: string): Promise<IssueModel>;
	UpdateIssue(properties: IssuePropertiesDTO): Promise<IssueModel>;
	PublishIssue(issueId: number, state: number): Promise<any>;
	LoadFolio(issueId: number): Promise<IssueFolioModel>;
	SaveFolio(issueId: number, folio: string): Promise<IssueFolioModel>;
	LoadViewerConfig(issueId: number): Promise<IssueViewerConfigDTO>;
	SaveViewerConfig(data: IssueViewerConfigDTO): Promise<IssueViewerConfigDTO>;
	UpdateIssueDate(issue: IssueModel): Promise<IssueModel>;
	GetSourceFiles(issueId: number): Promise<SourceFileModel[]>;
}

export class IssueService implements IIssueService {
	private svc: IssueClient = new IssueClient();
	private foliosvc: IssueFolioClient = new IssueFolioClient();
	private viewerConfig: IssueViewerConfigClient = new IssueViewerConfigClient();

	public async UpdateIssueDate(issue: IssueModel): Promise<IssueModel> {
		return await this.svc.setIssueDate(issue.id as number, issue.issueDate as Date);
	}

	public async LoadViewerConfig(issueId: number): Promise<IssueViewerConfigDTO> {
		return await this.viewerConfig.getIssueViewerConfig(issueId);
	}

	public async SaveViewerConfig(data: IssueViewerConfigDTO): Promise<IssueViewerConfigDTO> {
		return await this.viewerConfig.saveIssueViererConfig(data);
	}

	public async LoadFolio(issueId: number): Promise<IssueFolioModel> {
		return await this.foliosvc.getFolioForIssue(issueId);
	}

	public async SaveFolio(issueId: number, folio: string): Promise<IssueFolioModel> {
		return await this.foliosvc.saveIssueFolio(issueId, folio);
	}

	public async DeleteIssue(issueId: number): Promise<any> {
		return await this.svc.deleteIssue(issueId);
	}

	public async PublishIssue(issueId: number, state: number): Promise<any> {
		return await this.svc.publishIssue(issueId, state);
	}

	public async UpdateIssue(properties: IssuePropertiesDTO): Promise<IssueModel> {
		return await this.svc.updateIssue(properties);
	}

	public async getIssueProperties(issueId: number): Promise<IssuePropertiesDTO> {
		return await this.svc.getIssueProperties(issueId);
	}
	public async getIssue(issueId: number): Promise<IssueModel> {
		return await this.svc.getIssue(issueId);
	}
	public async getIssueDomains(issueId: number): Promise<string[]> {
		return await this.svc.getIssueWithUrls(issueId);
	}
	public async getAccountIdForIssue(issueId: number): Promise<number> {
		const issue: IssueModel = await this.getIssue(issueId);
		if (issue !== undefined && issue.publication !== undefined && issue.publication.customerAccountId !== undefined) {
			return issue.publication.customerAccountId;
		}
		return 0;
	}

	public async CreateEmptyIssue(titleId: number, name: string): Promise<IssueModel> {
		const newIssue: NewIssueData = new NewIssueData();
		newIssue.articles = [];
		newIssue.issueName = name;
		newIssue.publicationId = titleId;
		const iss = await this.svc.addIssueWithArticles(newIssue);
		return iss;
	}

	public async GetSourceFiles(issueId: number): Promise<SourceFileModel[]> {
		return await this.svc.getIssueSourcePdf(issueId);
	}


}
